import { Pipe, PipeTransform } from '@angular/core';
import { productColSpan } from './product-col-span.pipe';

@Pipe({
    name: 'productWidth',
    standalone: true
})
export class ProductWidthPipe implements PipeTransform {
    transform(colSpan?: number, rowSpan?: number, isBanner?: boolean, listingSize?: number): number {
        return productWidth(colSpan, rowSpan, isBanner, listingSize);
    }
}

export function productWidth(colSpan = 1, rowSpan = 1, isBanner = false, listingSize = 2): number {
    return ((colSpan === 2 && rowSpan !== 2) ||
        (productColSpan(colSpan, rowSpan, isBanner, listingSize) === 3 && listingSize === 3) ||
        (productColSpan(colSpan, rowSpan, isBanner, listingSize) === 4 && listingSize === 4)) &&
        !isBanner
        ? 6
        : 12;
}
